import { createSelector } from 'redux-orm';

import orm from '../orm';
import { pathSelector } from './path';
import { isLocalId } from '../utils/local-id';

export const factoriesSelector = createSelector(orm, ({ Factory }) => {
  const factories = Factory.all().toModelArray();
  return factories.map((factory) => {
    let notificationsTotal = 0;
    factory.sites?.toRefArray().forEach((site) => {
      site.devices?.toRefArray().forEach((device) => {
        notificationsTotal += device.getUnreadNotificationsQuerySet().count();
      });
    });

    const firstSite = factory.sites.first();
    const firstSiteId = firstSite && firstSite.id;

    return {
      ...factory.ref,
      notificationsTotal,
      firstSiteId,
    };
  });
});

export const currentFactorySelector = createSelector(
  orm,
  (state) => pathSelector(state).factoryId,
  ({ Factory }, id) => {
    if (!id) {
      return id;
    }

    const factoryModel = Factory.withId(id);

    if (!factoryModel) {
      return factoryModel;
    }

    return factoryModel.ref;
  },
);

export const sitesForCurrentFactorySelector = createSelector(
  orm,
  (state) => pathSelector(state).factoryId,
  ({ Factory }, id) => {
    if (!id) {
      return id;
    }

    const factoryModel = Factory.withId(id);

    if (!factoryModel) {
      return factoryModel;
    }

    return factoryModel
      .getOrderedSitesQuerySet()
      .toRefArray()
      .map((site) => ({
        ...site,
        isPersisted: !isLocalId(site.id),
      }));
  },
);
